import cn from 'clsx';

import { FormattedPoll } from '@utils/Poll';

import PollOptionCard from '@components/elements/PollOptionCard';
import VoteProgressBar from './VoteProgressBar';
import { isPast } from 'date-fns';
import { PollStatus } from '@sdk/models';

interface PollQuestionCardProps {
  index: number;
  poll: FormattedPoll & { isVotePeriod: boolean; isPledgePeriod: boolean };
  subPoll?: FormattedPoll;
  vote?: string[] | string;
  selectable?: boolean;
  onSelect?: (optionId: string, type?: string) => void;
  neon?: string;
}

const COLORS = [
  'yellow',
  'magenta',
  'orange',
  'green',
  'blue-light',
  'salmon',
  'purple',
  'yellow',
  'red-pastel',
];

const PollQuestionCard: React.FC<PollQuestionCardProps> = ({
  index,
  poll,
  subPoll,
  vote,
  onSelect,
  selectable,
  neon,
}) => {
  console.log(poll);
  return (
    <div
      className="text-poll-questionCard-color"
      style={{ wordBreak: 'break-all' }}
    >
      <div className="flex flex-col">
        <div className="py-2 text-lg text-poll-questionCard-question-color">
          QUESTION {index}
        </div>
        <h2 className="mb-4 text-3xl text-poll-questionCard-question-color">
          {subPoll?.question || poll.question}
        </h2>
        {/* <h3 className="text-2xl text-purple">My Vote</h3> */}
      </div>
      <div
        className={cn('space-y-2 pb-4', {
          'opacity-90': !poll.isVotePeriod,
        })}
      >
        {(subPoll || poll)?.options?.map((option, i) => {
          if (!selectable && !poll.isVotePeriod && isPast(poll.endDate)) {
            let isDraw = poll.status === PollStatus.SWING;
            let isWinner = !isDraw && option.id === poll.winOption?.id;

            return (
              <VoteProgressBar
                key={`poll-option-${option.id}`}
                draw={isDraw}
                winner={isWinner}
                title={option.title ? option.title : undefined}
                value={Math.max(option.count || 0, 0)}
                max={(subPoll || poll).voteCount}
              />
            );
          }

          // Get color, limit by length and carousell
          let colorIx = i;
          while (colorIx >= COLORS.length) {
            colorIx = colorIx - COLORS.length;
          }

          return (
            <PollOptionCard
              color={COLORS[colorIx]}
              key={`poll-option-${option.id}`}
              active={
                typeof vote === 'string'
                  ? vote === option.id
                  : !!vote?.find((item) => item === option.id)
              }
              neon={neon}
              title={option.title || `Option ${i}`}
              description={option.description || undefined}
              price={option.detail?.price || undefined}
              image={option.detail?.image?.url}
              video={option.detail?.video || undefined}
              disabled={!selectable && !poll.isVotePeriod}
              onClick={
                (selectable || poll.isVotePeriod) && onSelect !== undefined
                  ? () =>
                      onSelect(
                        option.id,
                        typeof vote !== 'string'
                          ? !!vote?.find((item) => item === option.id)
                            ? 'unselect'
                            : 'select'
                          : undefined
                      )
                  : undefined
              }
            />
          );
        })}
      </div>
    </div>
  );
};

export default PollQuestionCard;
